import { useEffect } from "react";
import { X } from "lucide-react";
import KaraokeSharePanel from "./KaraokeSharePanel";

/**
 * KaraokeShareModal — thin wrapper around <KaraokeSharePanel /> so a
 * user can re-open the share flow for any completed karaoke_jobs row
 * even after the original render modal has closed.
 *
 * Props:
 *   open           bool
 *   jobId          string   — target karaoke job (must be succeeded)
 *   sourceLabel    string   — friendly label shown in the header
 *   defaultCaption string   — optional pre-filled caption
 *   onClose()      —
 */
export function KaraokeShareModal({ open, jobId, sourceLabel, defaultCaption, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open || !jobId) return null;

  return (
    <div
      data-testid="karaoke-share-modal"
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: "rgba(0,0,0,0.65)", backdropFilter: "blur(4px)" }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-2xl rounded-2xl border p-5"
        style={{ background: "#0f1117", borderColor: "#232632" }}
      >
        <div className="flex items-start justify-between mb-3">
          <div className="min-w-0">
            <div className="text-white truncate" style={{ fontSize: 15, fontWeight: 600 }}>
              Share karaoke → socials
            </div>
            {sourceLabel && (
              <div className="type-caption text-neutral-400 truncate mt-0.5">
                {sourceLabel}
              </div>
            )}
          </div>
          <button
            data-testid="karaoke-share-modal-close"
            onClick={onClose}
            className="h-8 w-8 rounded-full flex items-center justify-center transition"
            style={{ background: "#232632", color: "#a9b3c9" }}
          >
            <X size={14} />
          </button>
        </div>

        <KaraokeSharePanel
          jobId={jobId}
          defaultCaption={defaultCaption}
          testidPrefix="karaoke-share-modal"
        />
      </div>
    </div>
  );
}

export default KaraokeShareModal;
